import { AppShell } from '../components/Layout/AppShell';
import { Header } from '../components/Layout/Header';
import { Container } from '../components/Layout/Container';
import { ForgeInterrupt } from '../components/Challenges/ForgeInterrupt';
import styles from '../App.module.css';

/**
 * Interrupt Page - Hidden urgent challenge page
 * 
 * Features:
 * - Displays ForgeInterrupt challenge component
 * - Reuses AppShell layout for consistency
 * - Minimal layout focused on the urgent challenge
 */
export function Interrupt() {
  return (
    <AppShell>
      <div className={styles.app}>
        <Header />
        
        <main className={styles.main}>
          <Container>
            <section className={`${styles.section} ${styles.fullWidth}`}>
              <ForgeInterrupt />
            </section>
          </Container>
        </main>
      </div>
    </AppShell>
  );
}
